module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDI2IDI2Ij4KICA8cGF0aCBpZD0iU3VidHJhY3Rpb25fMzAiIGRhdGEtbmFtZT0iU3VidHJhY3Rpb24gMzAiIGQ9Ik0yNiwyNkgwVjBIMjZWMjZaTTMuNDY2LDE5LjV2MS4zSDE1LjZWMTkuNVptMTMuODY3LTUuMnYzLjloNS4yVjE0LjNaTTMuNDY2LDE2Ljl2MS4zSDE1LjZWMTYuOVptMC0yLjZ2MS4zSDE1LjZWMTQuM1ptMC01LjJ2MS4zSDE1LjZWOS4xWk0xNy4zMzMsMy45VjcuOGg1LjJWMy45Wk0zLjQ2Niw2LjVWNy44SDE1LjZWNi41Wm0wLTIuNlY1LjJIMTUuNlYzLjlaIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/msdetail_order_info.svg
// module id = nSZs
// module chunks = 0